/**
 * 本模块主要作用：混入模式，在vue页面中引入后，绑定到mixins属性上
 */
import { deviceEnquire, DEVICE_TYPE } from "./device";
import { mapState } from "vuex";

//混入计算函数和公共方法
const mixin = {
  computed: {
    ...mapState({
      layoutMode: state => state.app.layout,
      navTheme: state => state.app.theme,
      primaryColor: state => state.app.color,
      colorWeak: state => state.app.weak,
      fixedHeader: state => state.app.fixedHeader,
      fixSiderbar: state => state.app.fixSiderbar,
      fixSidebar: state => state.app.fixSiderbar,
      contentWidth: state => state.app.contentWidth,
      autoHideHeader: state => state.app.autoHideHeader,
      sidebarOpened: state => state.app.sidebar,
      multiTab: state => state.app.multiTab,
	  styleSetting: state => state.app.styleSetting
    })
  },
  methods: {
    isTopMenu() {
      return this.layoutMode === "topmenu";
    },
    isSideMenu() {
      return !this.isTopMenu();
    }
  }
};

//混入设备
const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  methods: {
    isMobile() {
      return this.device === DEVICE_TYPE.MOBILE;
    },
    isDesktop() {
      return this.device === DEVICE_TYPE.DESKTOP;
    },
    isTablet() {
      return this.device === DEVICE_TYPE.TABLET;
    }
  }
};

//混入判断当前设备
const AppDeviceEnquire = {
  mounted() {
    const { $store } = this;
    //deviceEnquire返回当前的设备信息，然后通过store事件传递，保存到相应的变量中
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit("TOGGLE_DEVICE", "desktop");
          $store.dispatch("setSidebar", true);
          break;
        case DEVICE_TYPE.TABLET:
          $store.commit("TOGGLE_DEVICE", "tablet");
          $store.dispatch("setSidebar", false);
          break;
        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit("TOGGLE_DEVICE", "mobile");
          $store.dispatch("setSidebar", true);
          break;
      }
    });
  }
};

export { mixin, AppDeviceEnquire, mixinDevice };
